import { MutationTree } from 'vuex';
import CategoriesState from '../types/CategoriesTypes'

const mutations: MutationTree<CategoriesState> = {
  updateCategories (state, payload) {
    state.categories = payload;
  },
  setRawCategories (state, payload) {
    state.rawCategories = payload
  },
  setCategoriesLoaded (state, categoriesAmount) {
    state.categories_loaded = categoriesAmount
  },
  setProducts (state, payload) {
    state.categoriesProducts = payload;
  },
  updateProducts (state, payload) {
    let category = state.categoriesProducts.find(item => item.category.entity_id === payload.category.entity_id)
    if (category === undefined) {
      state.categoriesProducts.push(payload)
      return
    }
    if (payload.products.length > 0) {
      category.products = payload.products;
      category.productsTotal = payload.productsTotal
      if (category.categoryIds !== payload.categoryIds) {
        category.categoryIds = payload.categoryIds;
      }
    } else {
      let identifier = state.categoriesProducts.indexOf(category);
      state.categoriesProducts.splice(identifier, 1);
    }
  },
  cleanupSliderProducts (state) {
    state.rawCategories = []
    state.categoriesProducts = []
  }
}

export default mutations
